<script>
    // Stage names and effects mirror the State and Off tables of
    // accounts_receivable/docs/rules/collections-hold.md. Values: 0 none, 1 execs, 2 customers, 3 pumpers back.
    const STAGES = {
        1: {
            name: 'Stage 1 — execs paused',
            blocked: ['Exec'],
            off: 'Exec logins, scheduled reports, running or creating any report, and exports are off. Pumpers can still sign in and enter data.'
        },
        2: {
            name: 'Stage 2 — customers paused',
            blocked: ['Exec', 'Pumper', 'Guest'],
            off: 'Everything in stage 1, plus pumper and guest logins. Nobody at the client can sign in.'
        },
        3: {
            name: 'Stage 3 — pumpers back',
            blocked: ['Exec', 'Guest'],
            off: 'Exec and guest logins stay off. Pumpers can sign in and enter data. Reports, exports and well performance stay off.'
        }
    };

    export default {
        props: {
            hold: { type: Number, default: 0 },
            // Pass a role name ("Exec", "Pumper", "Guest") to say whether this user is the one blocked.
            role: { type: String, default: null }
        },
        computed: {
            stage() {
                return STAGES[this.hold] || null;
            },
            roleIsBlocked() {
                return !!this.role && !!this.stage && this.stage.blocked.includes(this.role);
            }
        }
    };
</script>

<template>
    <div v-if="stage" class="alert alert-warning py-2 mb-2" role="status">
        <strong>A/R collections hold: {{ stage.name }}</strong>
        <div v-if="role" class="mt-1">
            <template v-if="roleIsBlocked">
                This {{ role.toLowerCase() }} is <strong>blocked, not disabled</strong>. The account is untouched and the user comes back on
                its own when the balance is paid.
            </template>
            <template v-else>This {{ role.toLowerCase() }} can still sign in.</template>
        </div>
        <div class="mt-1">{{ stage.off }}</div>
        <div class="mt-1 small">Lifting the hold restores exactly what the client had on before.</div>
    </div>
</template>
